"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _QuickAccessPanel = _interopRequireDefault(require("./QuickAccessPanel"));

var _sections = require("../sections");

var _components = require("../../../common/components");

var _constants = require("../constants");

require("../styles/_sub-brand.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * quadratic easing in/out - acceleration until halfway, then deceleration
 * http://gizma.com/easing/
 *
 * @param {Object} { currentTime, start value, change in value, duration}
 *
 * @return number
 */


var easeInOutQuad = function easeInOutQuad(_ref) {
  var currentTime = _ref.currentTime,
      start = _ref.start,
      change = _ref.change,
      duration = _ref.duration;
  var newCurrentTime = currentTime / (duration / 2);

  if (newCurrentTime < 1) {
    return change / 2 * newCurrentTime * newCurrentTime + start;
  }

  newCurrentTime -= 1;
  return -change / 2 * (newCurrentTime * (newCurrentTime - 2) - 1) + start;
};

var SubBrand = /*#__PURE__*/function (_Component) {
  _inherits(SubBrand, _Component);

  var _super = _createSuper(SubBrand);

  function SubBrand(props) {
    var _this;

    _classCallCheck(this, SubBrand);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (assetId) {
      return function () {
        _this.setState({
          modalVisible: true,
          modalAssetId: assetId
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _lodash.default)(function () {
      return [{
        action: _this.handleEditBrand,
        label: 'Update Brand'
      }, {
        action: _this.handleDeleteSubBrand,
        label: 'Delete',
        isRed: true
      }];
    }));

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCoverImageUpload", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
        var organisationId, _this$props, apolloClient, updateOrganisationSubBrand, subBrandId, _files$slice, _files$slice2, file, coverImageKey, url;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                organisationId = _this.props.organisationId;

                _this.setState({
                  coverImageSaving: true
                });

                _this$props = _this.props, apolloClient = _this$props.apolloClient, updateOrganisationSubBrand = _this$props.updateOrganisationSubBrand, subBrandId = _this$props.subBrandId;
                _files$slice = files.slice(-1), _files$slice2 = _slicedToArray(_files$slice, 1), file = _files$slice2[0];
                coverImageKey = "organisation/".concat(organisationId, "/subBrand/").concat(subBrandId, "/coverImage");
                _context.prev = 5;
                _context.next = 8;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  bucketKey: coverImageKey,
                  file: file,
                  organisationId: organisationId
                });

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);
                (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                });

              case 13:
                url = file.preview.url;

                _this.setState({
                  localCoverImageUrl: url,
                  coverImageSaving: false
                });

                updateOrganisationSubBrand({
                  coverImageKey: coverImageKey
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 10]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleSaveProfileImage", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
        var _this$props2, apolloClient, updateOrganisationSubBrand, subBrandId, organisationId, _files$slice3, _files$slice4, file, profileImageKey, url;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = _this.props, apolloClient = _this$props2.apolloClient, updateOrganisationSubBrand = _this$props2.updateOrganisationSubBrand, subBrandId = _this$props2.subBrandId, organisationId = _this$props2.organisationId;
                _files$slice3 = files.slice(-1), _files$slice4 = _slicedToArray(_files$slice3, 1), file = _files$slice4[0];
                profileImageKey = "organisation/".concat(organisationId, "/subBrand/").concat(subBrandId, "/profileImage");
                _context2.prev = 3;
                _context2.next = 6;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  bucketKey: profileImageKey,
                  file: file,
                  organisationId: organisationId
                });

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);
                (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                });

              case 11:
                url = file.preview.url;

                _this.setState({
                  localProfileImageUrl: url
                });

                updateOrganisationSubBrand({
                  profileImageKey: profileImageKey
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 8]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleModalSave", function () {
      var updateOrganisationSubBrand = _this.props.updateOrganisationSubBrand;
      var description = _this.state.description;

      _this.setState(function (_ref4) {
        var subBrandData = _ref4.subBrandData;
        return {
          subBrandData: _objectSpread(_objectSpread({}, subBrandData), {}, {
            description: description
          })
        };
      });

      updateOrganisationSubBrand({
        description: description
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadSubBrandData", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(initialHash) {
        var getOrganisationSubBrand, _yield$getOrganisatio, error, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                getOrganisationSubBrand = _this.props.getOrganisationSubBrand;
                _context3.prev = 1;
                _context3.next = 4;
                return getOrganisationSubBrand();

              case 4:
                _yield$getOrganisatio = _context3.sent;
                error = _yield$getOrganisatio.error;
                data = _yield$getOrganisatio.data;

                if (!error) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", void _this.setState({
                  error: error
                }));

              case 9:
                if (data) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return");

              case 11:
                _context3.next = 13;
                return _this.retrieveBucketKeyUrls(data.getOrganisationSubBrand, initialHash);

              case 13:
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](1);

                _this.setState({
                  error: _context3.t0.message
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 15]]);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "retrieveBucketKeyUrls", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(organisationSubBrandData, initialHash) {
        var _this$props3, fetchAssets, apolloClient, organisationId, subBrandWithImage;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props3 = _this.props, fetchAssets = _this$props3.fetchAssets, apolloClient = _this$props3.apolloClient, organisationId = _this$props3.organisationId;
                _context4.prev = 1;
                _context4.next = 4;
                return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apolloClient,
                  data: organisationSubBrandData,
                  organisationId: organisationId,
                  substitutedKeys: ['coverImageKey', 'profileImageKey']
                });

              case 4:
                subBrandWithImage = _context4.sent;

                _this.setState({
                  subBrandData: subBrandWithImage,
                  initialHash: initialHash
                });

                fetchAssets(subBrandWithImage);
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);

                _this.setState({
                  subBrandData: organisationSubBrandData,
                  initialHash: initialHash
                });

                fetchAssets(organisationSubBrandData);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 9]]);
      }));

      return function (_x4, _x5) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleEditDetailsBtnClick", function () {
      _this.setState({
        showEditDetailsModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseEditDetailsModal", function () {
      _this.setState({
        showEditDetailsModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDescriptionInputChange", function (result) {
      _this.setState({
        description: (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditBrand", function () {
      var _this$props4 = _this.props,
          subBrandId = _this$props4.subBrandId,
          history = _this$props4.history;
      history.push("/brand/edit/".concat(subBrandId, "#1"));
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteSubBrand", function () {
      var _this$props5 = _this.props,
          history = _this$props5.history,
          deleteSubBrand = _this$props5.deleteSubBrand,
          subBrandId = _this$props5.subBrandId;
      deleteSubBrand(subBrandId).then(function () {
        history.push('/');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setRef", function (node, hash) {
      // $FlowFixMe
      _this[hash] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (hash) {
      // $FlowFixMe
      if (_this[hash]) {
        var element = document.getElementById('sub-brand-container'); // $FlowFixMe

        _this.smoothScroll({
          element: element,
          to: _this[hash].offsetTop,
          duration: 500
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "smoothScroll", function (_ref7) {
      var duration = _ref7.duration,
          element = _ref7.element,
          to = _ref7.to;
      var start = element.scrollTop;
      var change = to - start;
      var startDate = new Date().getTime();

      var animateScroll = function animateScroll() {
        var currentDate = new Date().getTime();
        var currentTime = currentDate - startDate; // eslint-disable-next-line no-param-reassign

        element.scrollTop = easeInOutQuad({
          currentTime: currentTime,
          start: start,
          change: change,
          duration: duration
        });

        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        } else {
          // eslint-disable-next-line no-param-reassign
          element.scrollTop = to;
        }
      };

      animateScroll();
    });

    _this.state = {
      showEditDetailsModal: false,
      coverImageSaving: false,
      initialHash: '',
      modalAssetId: '',
      modalVisible: false
    };
    return _this;
  }

  _createClass(SubBrand, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var history, hash, locationHash;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                history = this.props.history;
                hash = history.location.hash;
                locationHash = hash.substring(1, hash.length);
                _context5.next = 5;
                return this.loadSubBrandData(locationHash);

              case 5:
                if (locationHash) {
                  this.scrollTo(locationHash);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          showEditDetailsModal = _this$state.showEditDetailsModal,
          coverImageSaving = _this$state.coverImageSaving,
          subBrandData = _this$state.subBrandData,
          localCoverImageUrl = _this$state.localCoverImageUrl,
          localProfileImageUrl = _this$state.localProfileImageUrl,
          initialHash = _this$state.initialHash,
          error = _this$state.error,
          modalVisible = _this$state.modalVisible,
          modalAssetId = _this$state.modalAssetId;
      var _this$props6 = this.props,
          history = _this$props6.history,
          orgPermissions = _this$props6.orgPermissions,
          apolloClient = _this$props6.apolloClient,
          containerSize = _this$props6.containerSize;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      if (subBrandData === null) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.NotFound, null);
      }

      if (subBrandData === void 0) {
        return /*#__PURE__*/_react.default.createElement(_uiKit.Loader, null);
      }

      var name = subBrandData.name,
          coverImageKey = subBrandData.coverImageKey,
          description = subBrandData.description,
          profileImageKey = subBrandData.profileImageKey;
      var hasManagePermission = (0, _commonReact.hasPermission)('MANAGE_ORGANISATION', orgPermissions);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-brand page",
        id: "sub-brand-container"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.ManageAssetModal, {
        assetId: modalAssetId,
        isVisible: modalVisible,
        apiClient: apolloClient,
        onClose: this.closeModal
      }), /*#__PURE__*/_react.default.createElement(_components.PageHeaderWithBackground, {
        title: name,
        subtitle: "My Organisation",
        subtitleLink: "/organisation",
        imageUrl: localCoverImageUrl || coverImageKey,
        buttonBusy: coverImageSaving,
        handleFilesChange: this.handleCoverImageUpload,
        actionBtnMobileIcon: "edit",
        hasManagePermission: hasManagePermission,
        actionPopupOptions: this.getActionOptions()
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-brand__inner column"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-brand__main"
      }, /*#__PURE__*/_react.default.createElement(_components.BrandingDescription, {
        name: name,
        containerSize: containerSize,
        imageUrl: localProfileImageUrl || profileImageKey,
        descriptionText: description || '',
        handleClick: this.handleEditDetailsBtnClick,
        showEditDetailsModal: showEditDetailsModal,
        handleModalClose: this.handleCloseEditDetailsModal,
        handleModalSave: this.handleModalSave,
        handleDescriptionInputChange: this.handleDescriptionInputChange,
        handleUploadImage: this.handleSaveProfileImage,
        hasManagePermission: hasManagePermission
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-brand__main__sections"
      }, /*#__PURE__*/_react.default.createElement(_sections.BrandValues, _extends({
        setRef: function setRef(node) {
          return _this2.setRef(node, _constants.hashList[0].hash);
        },
        gotoId: _constants.hashList[0].hash
      }, subBrandData)), /*#__PURE__*/_react.default.createElement(_sections.Logos, _extends({
        setRef: function setRef(node) {
          return _this2.setRef(node, _constants.hashList[1].hash);
        },
        gotoId: _constants.hashList[1].hash
      }, subBrandData)), /*#__PURE__*/_react.default.createElement(_sections.Typography, _extends({
        setRef: function setRef(node) {
          return _this2.setRef(node, _constants.hashList[2].hash);
        },
        gotoId: _constants.hashList[2].hash
      }, subBrandData)), /*#__PURE__*/_react.default.createElement(_sections.Colors, _extends({
        setRef: function setRef(node) {
          return _this2.setRef(node, _constants.hashList[3].hash);
        },
        gotoId: _constants.hashList[3].hash
      }, subBrandData)), /*#__PURE__*/_react.default.createElement(_sections.Videos, _extends({
        setRef: function setRef(node) {
          return _this2.setRef(node, _constants.hashList[4].hash);
        },
        gotoId: _constants.hashList[4].hash,
        openAssetModal: this.openModal
      }, subBrandData)), /*#__PURE__*/_react.default.createElement(_sections.Styleguides, _extends({
        setRef: function setRef(node) {
          return _this2.setRef(node, _constants.hashList[5].hash);
        },
        gotoId: _constants.hashList[5].hash,
        openAssetModal: this.openModal
      }, subBrandData)))), containerSize.width >= _vars.NUMERIC_MEDIA_SIZES.medium + 1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-brand__quick-access-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
        rounded: true,
        className: "quick-access"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Accordion, {
        titles: "Quick Access"
      }, /*#__PURE__*/_react.default.createElement(_QuickAccessPanel.default, {
        hashList: _constants.hashList,
        history: history,
        initialHash: initialHash,
        scrollTo: this.scrollTo
      }))))));
    }
  }]);

  return SubBrand;
}(_react.Component);

exports.default = SubBrand;